// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, CardContent, Checkbox, Divider, FormControlLabel, Grid, IconButton, Snackbar, Tooltip, Typography } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';


// CUSTOM 
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { uploadPdfStore } from 'store/uploaders';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';



export const PruebasIngreso = (props:any) => {

    const dispatch = useDispatch();

    // VISITA DOMICILIARIA 
    const [vidomsi, setViDomSi] = useState(false);
    const [vidomno, setViDomNo] = useState(true);


    // PRUEBA PSICOTECNICA 
    const [psicotecsi, setPsicotecSi] = useState(false);
    const [psicotecno, setPsicotecNo] = useState(true);


    // EXAMENES MANIULACION ALIMENTOS
    const [manipualsi, setManipualSi] = useState(false);
    const [manipualno, setManipualNo] = useState(true);


    // EXAMEN ALTURAS
    const [alturasi, setAlturaSi] = useState(false);
    const [alturano, setAlturaNo] = useState(true);



    
    // EXAMEN MEDICO
    const [examenmedsi, setExamenMedSi] = useState(true);
    const [examenmedno, setExamenMedNo] = useState(false);


    
    // CONTRATO 
    const [contratosi, setContratoSi] = useState(false);
    const [contratono, setContratoNo] = useState(true);



    // CERTIFICADO ESTUDIO
    const [certificadoestudiosi, setCertificadoEstudioSi] = useState(false);
    const [certificadoestudiono, setCertificadoEstudioNo] = useState(true);



    // CERTIFICADO ESTUDIO
    const [certificadolaboralsi, setCertificadoLaboralSi] = useState(false);
    const [certificadolaboralno, setCertificadoLaboralNo] = useState(true);


    
     // VERIFICACION ADDRESS
     const [verificacionaddresi, setVerificacionAddressSi] = useState(false);
     const [verificacionaddreno, setVerificacionAddressNo] = useState(true);



     // ANTECEDENTES
     const [antecedentessi, setAntecedentesSi] = useState(false);
     const [antecedentesno, setAntecedentesNo] = useState(true);



     // ENTREVISTA
     const [entrevistasi, setEntrevistaSi] = useState(false);
     const [entrevistano, setEntrevistaNo] = useState(true);



    // ENTREVISTA SOCIODEMOGRAFICA
    const [sociodemograficasi, setSocioDemograficaSi] = useState(false);
    const [sociodemograficano, setSocioDemograficaNo] = useState(true);


    // ENCUESTA DME
    const [encuestadmesi,   setencuestaDmeSi] = useState(false);
    const [encuestadmeno,   setencuestaDmeNo] = useState(true);


    
    // COMPROMISO SST
    const [compromisosstsi,   setCompromisoSstSi] = useState(false);
    const [compromisosstno,   setCompromisoSstNo] = useState(true);
    
     

    const [showvisdom, setShowVisDom] = useState(false);


    // UPLOADERS 

    // VISITA DOMICILIARIA 
    const [percentage_upload_vi_dom, setPercentageUploadViDom]   = useState(0);

    // PRUEBA PSICOTECNICA 
    const [percentage_upload_psicotec, setPercentageUploadPsicotec]   = useState(0);

    // MANEJO ALIMENTOS
    const [percentage_upload_manejo_alimentos, setPercentageUploadManejoAlimentos]   = useState(0);

    // MANEJO ALIMENTOS
    const [percentage_upload_trabajo_alturas, setPercentageUploadTrabajoAlturas]   = useState(0);
    

    // MANEJO ALIMENTOS
    const [percentage_upload_examen_medico, setPercentageUploadExamenMedico]   = useState(0);
    

    // MANEJO ALIMENTOS
    const [percentage_upload_certificado_estudio, setPercentageUploadCertificadoEstudios]   = useState(0);


    // CERTIFICADO LABORAL
    const [percentage_upload_certificado_laboral, setPercentageUploadCertificadoLaboral]   = useState(0);


    // VERIFICACION ADRES
    const [percentage_upload_verificacion_adres, setPercentageUploadVerificacionAdres]   = useState(0);


    // ANTECEDENTES
    const [percentage_upload_antecedentes, setPercentageUploadAntecedentes]   = useState(0);
    

    // ENTREVISTA
    const [percentage_upload_entrevista, setPercentageUploadEntrevista]   = useState(0);


    // ENTREVISTA SOCIODEMOGRAFICA
    const [percentage_upload_entrevista_sociodemografica, setPercentageUploadSociodemografica]   = useState(0);
    
     
    // ENCUESTA DME
    const [percentage_upload_encuesta_dme, setPercentageUploadEncuestaDme]   = useState(0);


    // COMPROMISO SST 
    const [percentage_upload_compromiso_sst, setPercentageUploadCompromisoSst]   = useState(0);
    
    

    const formikProps:any = useFormikContext();


    const { formField: {
        // DATOS CLIENTE 
        vista_domiciliaria,
        fileVisitaDomiciliaria,
        prueba_psicotecnica,
        filePsicotecnica,
        manipulacion_alimentos,
        fileManipulacionAlimentos,
        trabajo_alturas,
        fileTrabajoAlturas,
        examen_medico,
        fileExamenMedico,
        contrato,
        certificado_estudios,
        fileCertificadoEstudios,
        certificado_laboral,
        fileCertificadoLaboral,
        verificacion_adres,
        fileVerificacionAdres,
        antecedentes,
        fileAntecedentes,
        entrevista,
        fileEntrevista,
        sociodemografica,
        fileSociodemografica,
        encuesta_dme,
        fileEncuestaDme,
        compromiso_sst,
        fileCompromisoSst,
      }
    } = props;


    // VISITA DOMICILIARIA 
    const visDomSi = () => {
        formikProps.setFieldValue('vista_domiciliaria', true);

        setViDomSi(true);
        setViDomNo(false);
        
    }
    const visDomNo = () => {
        formikProps.setFieldValue('vista_domiciliaria', false);
        setViDomSi(false);
        setViDomNo(true);
    }



    const uploadVisDom = async({ target }:any) => {
         
        formikProps.setFieldValue('fileVisitaDomiciliaria', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadViDom) );


      
      if (ok) {
         formikProps.setFieldValue('visita_domiciliaria_name_saved', data.pdfName);
      }

    }
    // END VISITA DOMICILIARIA 



    // PSICOTECNICA 
    const psicotecSi = () => {
        formikProps.setFieldValue('prueba_psicotecnica', true);

        setPsicotecSi(true);
        setPsicotecNo(false);
        
    }
    const psicotecNo = () => {
        formikProps.setFieldValue('prueba_psicotecnica', false);
        setPsicotecSi(false);
        setPsicotecNo(true);
    }
    const uploadPsiq = async({ target }:any) => {
         
        formikProps.setFieldValue('filePsicotecnica', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadPsicotec) );


      
      if (ok) {
         formikProps.setFieldValue('psicotecnica_name_saved', data.pdfName);
      }

    }
    // END PSICOTECNICA



    // MANIPULACION ALIMENTOS 
    const examenManAlimentosSi = () => {
        formikProps.setFieldValue('manipulacion_alimentos', true);

        setManipualSi(true);
        setManipualNo(false);
        
    }
    const examenManAlimentosNo = () => {
        formikProps.setFieldValue('manipulacion_alimentos', false);
        setManipualSi(false);
        setManipualNo(true);
    } 
    const uploadManipulacionAlimentos = async({ target }:any) => {
         
        formikProps.setFieldValue('fileManipulacionAlimentos', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadManejoAlimentos) );


      
      if (ok) {
         formikProps.setFieldValue('manipulacion_alimentos_name_saved', data.pdfName);
      }

    }
    // END MANIPULACION DE ALIMENTOS 


    
    // TRABAJO EN ALTURAS 
    const trabajoAlturasSi = () => {
        formikProps.setFieldValue('trabajo_alturas', true);

        setAlturaSi(true);
        setAlturaNo(false);
        
    }
    const trabajoAlturasNo = () => {
        formikProps.setFieldValue('trabajo_alturas', false);
        setAlturaSi(false);
        setAlturaNo(true);
    }
    const uploadTrabajoAlturas = async({ target }:any) => {
         
        formikProps.setFieldValue('fileTrabajoAlturas', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadTrabajoAlturas) );


      
      if (ok) {
         formikProps.setFieldValue('trabajo_altura_name_saved', data.pdfName);
      }

    }
    // END TRABAJO EN ALTURAS 



    // EXAMEN MEDICO 
    const examenMedicoSi = () => {
        formikProps.setFieldValue('examen_medico', true);
        setExamenMedSi(true);
        setExamenMedNo(false);
    }
    const examenMedicoNo = () => {
        formikProps.setFieldValue('examen_medico', false);
        setExamenMedSi(false);
        setExamenMedNo(true);
    }
    const uploadExamenMedico = async({ target }:any) => {
         
        formikProps.setFieldValue('fileExamenMedico', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadExamenMedico) );


      
      if (ok) {
         formikProps.setFieldValue('examen_medico_name_saved', data.pdfName);
      }

    }
    // END EXAMEN MEDICO 



    // CONTRATO 
    const contratoSi = () => {
        formikProps.setFieldValue('contrato', true);
        setContratoSi(true);
        setContratoNo(false);
    }
    const contratoNo = () => {
        formikProps.setFieldValue('contrato', false);
        setContratoSi(false);
        setContratoNo(true);
    }
    // END CONTRATO 


    // CERTIFICADO ESTUDIO 
    const certificadoEstudioSi = () => {
        formikProps.setFieldValue('certificado_estudios', true);
        setCertificadoEstudioSi(true);
        setCertificadoEstudioNo(false);
    }
    const certificadoEstudioNo = () => {
        formikProps.setFieldValue('certificado_estudios', false);
        setCertificadoEstudioSi(false);
        setCertificadoEstudioNo(true);
    }
    const uploadCertificadoEstudio = async({ target }:any) => {
         
        formikProps.setFieldValue('fileCertificadoEstudios', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadCertificadoEstudios) );


      
      if (ok) {
         formikProps.setFieldValue('certificado_estudios_name_saved', data.pdfName);
      }

    }
    // END CERTIFICADO ESTUDIO 


    
    // CERTIFICADO LABORAL 
    const certificadoLaboralSi = () => {
        formikProps.setFieldValue('certificado_laboral', true);
        setCertificadoLaboralSi(true);
        setCertificadoLaboralNo(false);
    }
    const certificadoLaboralNo = () => {
        formikProps.setFieldValue('certificado_laboral', false);
        setCertificadoLaboralSi(false);
        setCertificadoLaboralNo(true);
    }
    const uploadCertificadoLaboral = async({ target }:any) => {
         
        formikProps.setFieldValue('fileCertificadoLaboral', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadCertificadoLaboral) );


      
      if (ok) {
         formikProps.setFieldValue('certificado_laboral_name_saved', data.pdfName);
      }

    }
    // END CERTIFICADO LABORAL



    // VERIFICACION ADDRESS 
    const verificacionAddresSi = () => {
        formikProps.setFieldValue('verificacion_adres', true);
        setVerificacionAddressSi(true);
        setVerificacionAddressNo(false);
    }
    const verificacionAddresNo = () => {
        formikProps.setFieldValue('verificacion_adres', false);
        setVerificacionAddressSi(false);
        setVerificacionAddressNo(true);
    }
    const uploadVerificacionAdres = async({ target }:any) => {
         
        formikProps.setFieldValue('fileVerificacionAdres', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadVerificacionAdres) );


      
      if (ok) {
         formikProps.setFieldValue('verificacion_adres_name_saved', data.pdfName);
      }

    }
    // END VERIFICACION ADDRESS
    


    
    // ANTECEDENTES 
    const antecedentesSi = () => {
        formikProps.setFieldValue('antecedentes', true);
        setAntecedentesSi(true);
        setAntecedentesNo(false);
    }
    const antecedentesNo = () => {
        formikProps.setFieldValue('antecedentes', false);
        setAntecedentesSi(false);
        setAntecedentesNo(true);
    }
    const uploadAntecedentes = async({ target }:any) => {
         
        formikProps.setFieldValue('fileAntecedentes', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadAntecedentes) );


      
      if (ok) {
         formikProps.setFieldValue('antecedentes_name_saved', data.pdfName);
      }

    }
    // END ANTECEDENTES



    // ENTREVISTA 
    const entrevistaSi = () => {
        formikProps.setFieldValue('entrevista', true);
        setEntrevistaSi(true);
        setEntrevistaNo(false);
    }
    const entrevistaNo = () => {
        formikProps.setFieldValue('entrevista', false);
        setEntrevistaSi(false);
        setEntrevistaNo(true);
    }
    const uploaEntrevista = async({ target }:any) => {
         
        formikProps.setFieldValue('fileEntrevista', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadEntrevista) );


      
      if (ok) {
         formikProps.setFieldValue('entrevista_name_saved', data.pdfName);
      }

    }
    // END ENTREVISTA
    

    
    // ENTREVISTA SOCIODEMOGRAFICA
    const socioDemograficaSi = () => {
        formikProps.setFieldValue('sociodemografica', true);
        setSocioDemograficaSi(true);
        setSocioDemograficaNo(false);
    }
    const socioDemograficaNo = () => {
        formikProps.setFieldValue('sociodemografica', false);
        setSocioDemograficaSi(false);
        setSocioDemograficaNo(true);
    }
    const uploaEntrevistaSociodemografica = async({ target }:any) => {
         
        formikProps.setFieldValue('fileSociodemografica', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadSociodemografica) );


      
      if (ok) {
         formikProps.setFieldValue('sociodemografica_name_saved', data.pdfName);
      }

    }
    // END ENTREVISTA SOCIODEMOGRAFICA


    
    // ENCUESTA DME
    const encuestaDmeSi = () => {
        formikProps.setFieldValue('encuesta_dme', true);
        setencuestaDmeSi(true);
        setencuestaDmeNo(false);
    }
    const encuestaDmeNo = () => {
        formikProps.setFieldValue('encuesta_dme', false);
        setencuestaDmeSi(false);
        setencuestaDmeNo(true);
    }
    const uploadEncuestaDme = async({ target }:any) => {
         
        formikProps.setFieldValue('fileEncuestaDme', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadEncuestaDme) );


      
      if (ok) {
         formikProps.setFieldValue('encuesta_dme_name_saved', data.pdfName);
      }

    }
    // END ENCUESTA DME




    // COMPROMISO SST
    const compromisoSstSi = () => {
        formikProps.setFieldValue('compromiso_sst', true);
        setCompromisoSstSi(true);
        setCompromisoSstNo(false);
    }
    const compromisoSstNo = () => {
        formikProps.setFieldValue('compromiso_sst', false);
        setCompromisoSstSi(false);
        setCompromisoSstNo(true);
    } 
    const uploadCompromisoSst = async({ target }:any) => {
         
        formikProps.setFieldValue('fileCompromisoSst', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadCompromisoSst) );


      
      if (ok) {
         formikProps.setFieldValue('compromiso_sst_name_saved', data.pdfName);
      }

    }
    // END COMPROMISO SST



    
    // END PSICOTECNICA 



    const exmIngreso = async({ target }:any) => {
         
        formikProps.setFieldValue('filePsicotecnica', target.files[0]);
        const { ok, data } = await dispatch( uploadPdfStore( 'laboral-empleado', target.files[0], setPercentageUploadPsicotec) );


      
      if (ok) {
        formikProps.setFieldValue('visita_domiciliaria_name_saved', data.pdfName);
      }

    }
    // END PSICOTECNICA


  return (
    <div>


        <Grid container spacing={2}>

            <Grid size={{ xs: 3 }}>
            <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Visita domiciliaria?</Typography>
            

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => visDomSi() } name={'vista_domiciliaria_si'} checked={vidomsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => visDomNo() } name={'vista_domiciliaria_no'} checked={vidomno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>


                {/* FILE VISITA DOMICILIARIA  */}
                {
                    vidomsi
                     &&
                     <UploadButtonField accept={'application/pdf'} 
                                name={fileVisitaDomiciliaria.name} 
                                label={fileVisitaDomiciliaria.label} 
                                   required={true}
                                text={'Visita domiciliaria'} 
                                onChange={uploadVisDom}/>
                }
                

                {
                    vidomsi && formikProps.values.fileVisitaDomiciliaria 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                            <LinearProgressWithLabel style={{flex: 1, flexWrap: 'wrap'}} percentage={formikProps.values.visita_domiciliaria_name_saved ? 100 : percentage_upload_vi_dom} label={formikProps.values.fileVisitaDomiciliaria.name} hasIcon={true} />
                            {!(String(formikProps.values.visita_domiciliaria_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                              fileName={formikProps.values.visita_domiciliaria_name_saved} 
                              typeUrl="laboral-empleado" 
                              onOpenPdf={props.onOpenPdf} 
                            />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE VISITA DOMICILIARIA  */}

            </Grid>


            <Grid size={{ xs: 3 }}>
            </Grid>

            <Grid size={{ xs: 3 }}>
            <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Prueba Psicotecnica?</Typography>
            

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => psicotecSi() } name={'psicotecnica_si'} checked={psicotecsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => psicotecNo() } name={'psicotecnica_no'} checked={psicotecno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>


                {/* FILE PRUEBA PSICOTECNICA  */}
                {
                    psicotecsi
                     &&
                     <UploadButtonField accept={'application/pdf'} 
                                name={filePsicotecnica.name} 
                                label={filePsicotecnica.label} 
                                   required={true}
                                text={'Prueba psicotecnica'} 
                                onChange={uploadPsiq}/>
                }
                

                {
                    psicotecsi && formikProps.values.filePsicotecnica 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.psicotecnica_name_saved ? 100 : percentage_upload_psicotec} label={formikProps.values.filePsicotecnica.name} hasIcon={true} /> 
                        {!(String(formikProps.values.psicotecnica_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.psicotecnica_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE PRUEBA PSICOTECNICA  */}

            </Grid>


            <Grid size={{ xs: 3 }}>
                
            </Grid>


            <Grid size={{ xs: 3 }}>
            
            </Grid>



        </Grid>
        {/* END GRID  */}







        <Divider sx={{ marginTop: 5 }}/>
        <Grid container spacing={2} >
          <Typography variant='h6' sx={{  marginTop: 4, fontWeight: 'bold',  background: '#eceaea', padding: 2, width: '100%'  }}>Examenes habilidades tecnicas</Typography>
        </Grid>
        
        <Grid container spacing={2}>

            <Grid size={{ xs: 3 }}>
            <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Examen de manipulacion de alimentos?</Typography>
            

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => examenManAlimentosSi() } name={'alturas_si'} checked={manipualsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => examenManAlimentosNo() } name={'alturas_no'} checked={manipualno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>


                {/* MANIPULACION ALIMENTOS  */}
                {
                    manipualsi
                     &&
                     <UploadButtonField accept={'application/pdf'} 
                                name={fileManipulacionAlimentos.name} 
                                label={fileManipulacionAlimentos.label} 
                                   required={true}
                                text={'Manipulacion alimentos'} 
                                onChange={uploadManipulacionAlimentos}/>
                }
                 

                {
                    manipualsi && formikProps.values.fileManipulacionAlimentos 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.manipulacion_alimentos_name_saved ? 100 : percentage_upload_manejo_alimentos} label={formikProps.values.fileManipulacionAlimentos.name} hasIcon={true} /> 
                        {!(String(formikProps.values.manipulacion_alimentos_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.manipulacion_alimentos_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END MANIPULACION ALIMENTOS   */}

            </Grid>


            <Grid size={{ xs: 3 }}>
            </Grid>

            <Grid size={{ xs: 3 }}>
            <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Examen para trabajo en alturas?</Typography>
            

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => trabajoAlturasSi() } name={'trabajo_alturas_si'} checked={alturasi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => trabajoAlturasNo() } name={'trabajo_alturas_no'} checked={alturano} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>


                {/* FILE TRABAJO EN ALTURAS  */}
                {
                    alturasi
                     &&
                     <UploadButtonField accept={'application/pdf'} 
                                name={fileTrabajoAlturas.name} 
                                label={fileTrabajoAlturas.label} 
                                   required={true}
                                text={'Trabajo en alturas'} 
                                onChange={uploadTrabajoAlturas}/>
                }
                

                {
                    alturasi && formikProps.values.fileTrabajoAlturas 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.trabajo_altura_name_saved ? 100 : percentage_upload_trabajo_alturas} label={formikProps.values.fileTrabajoAlturas.name} hasIcon={true} /> 
                        {!(String(formikProps.values.trabajo_altura_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.trabajo_altura_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE TRABAJO EN ALTURAS  */}

            </Grid>




        </Grid>
        {/* END GRID  */}







        <Divider sx={{ marginTop: 4 }}/>
        <Grid container spacing={2} >
          <Typography variant='h6' sx={{  marginTop: 4, fontWeight: 'bold',  background: '#eceaea', padding: 2, width: '100%'  }}>Examenes Medicos</Typography>
        </Grid>

        
        <Grid container spacing={2}>


            <Grid size={{ xs: 3 }}>
               <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>Examen ingreso</Typography>
            
                
                    
                <UploadButtonField accept={'application/pdf'} 
                        name={fileExamenMedico.name} 
                        label={fileExamenMedico.label} 
                           required={ !(formikProps.values.fileExamenMedico || (formikProps.values.e_examen_medico_name_saved_edited && !String(formikProps.values.e_examen_medico_name_saved_edited).includes('dummy')) || (formikProps.values.examen_medico_name_saved && !String(formikProps.values.examen_medico_name_saved).includes('dummy'))) }
                        text={'Examen medico'} 
                        onChange={uploadExamenMedico}/>
                
                
                {/*FILE EXAMEN MEDICO  */}
                {
                    formikProps.values.fileExamenMedico 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.examen_medico_name_saved ? 100 : percentage_upload_examen_medico} label={formikProps.values.fileExamenMedico.name} hasIcon={true} /> 
                        {!(String(formikProps.values.examen_medico_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.examen_medico_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE EXAMEN MEDICO  */}




                

            </Grid>


            <Grid size={{ xs: 3 }}>
            </Grid>

            <Grid size={{ xs: 3 }}>
                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>Apto?</Typography>
            

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => examenMedicoSi() } name={'ex_medico_si'} checked={examenmedsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => examenMedicoNo() } name={'ex_medico_no'} checked={examenmedno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>


                

            </Grid>


            


        </Grid>
        {/* END GRID  */}





        <Divider sx={{ marginTop: 4 }}/>
        <Grid container spacing={2} >
          <Typography variant='h6' sx={{ marginTop: 4, fontWeight: 'bold',  background: '#eceaea', padding: 2, width: '100%' }}>Documentacíon requerida para el ingreso</Typography>
        </Grid>

        <Grid container spacing={2} sx={{  marginTop: 2 }}>

            <Grid size={{ xs: 3 }}>
               <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>Contrato?</Typography>
            
                
                    
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => contratoSi() } name={'contrato_si'} checked={contratosi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => contratoNo() } name={'contrato_no'} checked={contratono} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>

            </Grid>
            <Grid size={{ xs: 1}}></Grid>

            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Certificado de estudio?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => certificadoEstudioSi() } name={'certificado_estudio_si'} checked={certificadoestudiosi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => certificadoEstudioNo() } name={'certificado_estudio_no'} checked={certificadoestudiono} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                
                {/*FILE CERTIFICADO ESTUDIOS  */}
                {
                    certificadoestudiosi &&
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileCertificadoEstudios.name} 
                            label={fileCertificadoEstudios.label} 
                               required={true}
                            text={'Certificado de estudios'} 
                            onChange={uploadCertificadoEstudio}/>
                }
                    
                
                

                {
                    certificadoestudiosi && formikProps.values.fileCertificadoEstudios 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.certificado_estudios_name_saved ? 100 : percentage_upload_certificado_estudio} label={formikProps.values.fileCertificadoEstudios.name} hasIcon={true} /> 
                        {!(String(formikProps.values.certificado_estudios_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.certificado_estudios_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/*END FILE CERTIFICADO ESTUDIOS  */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>

            

            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Certificado laboral?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => certificadoLaboralSi() } name={'cert_laboral_si'} checked={certificadolaboralsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => certificadoLaboralNo() } name={'cert_laboral_no'} checked={certificadolaboralno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                

                {/*FILE CERTIFICADO LABORAL  */}
                {
                    certificadolaboralsi && 
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileCertificadoLaboral.name} 
                            label={fileCertificadoLaboral.label} 
                               required={true}
                            text={'Certificado laboral'} 
                            onChange={uploadCertificadoLaboral}/>
                }
                    
                
                

                {
                    certificadolaboralsi && formikProps.values.fileCertificadoLaboral 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.certificado_laboral_name_saved ? 100 : percentage_upload_certificado_laboral} label={formikProps.values.fileCertificadoLaboral.name} hasIcon={true} /> 
                        {!(String(formikProps.values.certificado_laboral_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.certificado_laboral_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE CERTIFICADO LABORAL  */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


        </Grid>
        {/* END GRID  */}


        <Grid container spacing={2} sx={{ borderTop: '2px solid #eceaea', marginTop: 4 }}>

            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Verificación ADRES?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => verificacionAddresSi() } name={'ver_address_si'} checked={verificacionaddresi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => verificacionAddresNo() } name={'ver_address_no'} checked={verificacionaddreno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                
                {/*FILE VERIFICACION ADRES  */}
                {
                    verificacionaddresi &&
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileVerificacionAdres.name} 
                            label={fileVerificacionAdres.label} 
                               required={true}
                            text={'Verificación ADRES'}  
                            onChange={uploadVerificacionAdres}/>
                }
                    
                
                

                {
                    verificacionaddresi && formikProps.values.fileVerificacionAdres 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.verificacion_adres_name_saved ? 100 : percentage_upload_verificacion_adres} label={formikProps.values.fileVerificacionAdres.name} hasIcon={true} /> 
                        {!(String(formikProps.values.verificacion_adres_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.verificacion_adres_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE VERIFICACION ADRES  */}

            </Grid>

            <Grid size={{ xs: 1}}></Grid>

            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Antecedentes?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => antecedentesSi() } name={'antecedentes_si'} checked={antecedentessi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => antecedentesNo() } name={'antecedentes_no'} checked={antecedentesno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                
                {/*FILE ANTECEDENTES  */}
                {
                    antecedentessi && 
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileAntecedentes.name} 
                            label={fileAntecedentes.label} 
                               required={true}
                            text={'Antecedentes'} 
                            onChange={uploadAntecedentes}/>
                }
                    
                
                

                {
                    antecedentessi && formikProps.values.fileAntecedentes 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.antecedentes_name_saved ? 100 : percentage_upload_antecedentes} label={formikProps.values.fileAntecedentes.name} hasIcon={true} /> 
                        {!(String(formikProps.values.antecedentes_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.antecedentes_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE ANTECEDENTES  */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Entrevista?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => entrevistaSi() } name={'entrevista_si'} checked={entrevistasi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => entrevistaNo() } name={'entrevista_no'} checked={entrevistano} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                
                {/*FILE ENTREVISTA  */}
                {
                    entrevistasi && 
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileEntrevista.name} 
                            label={fileEntrevista.label} 
                               required={true}
                            text={'Entrevista'} 
                            onChange={uploaEntrevista}/>
                }
                    
                
                

                {
                    entrevistasi && formikProps.values.fileEntrevista 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.entrevista_name_saved ? 100 : percentage_upload_entrevista} label={formikProps.values.fileEntrevista.name} hasIcon={true} /> 
                        {!(String(formikProps.values.entrevista_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.entrevista_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE ENTREVISTA  */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


        </Grid>
        {/* END GRID  */}



        <Grid container spacing={2} sx={{ borderTop: '2px solid #eceaea', marginTop: 4 }}>

            <Grid size={{ xs: 3 }} >

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Encuesta sociodemografica?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => socioDemograficaSi() } name={'sociodemografica_si'} checked={sociodemograficasi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => socioDemograficaNo() } name={'sociodemografica_no'} checked={sociodemograficano} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                
                {/*FILE ENTREVISTA SOCIODEMOGRAFICA */}
                {
                    sociodemograficasi &&
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileSociodemografica.name} 
                            label={fileSociodemografica.label} 
                               required={true}
                            text={'Sociodemografica'} 
                            onChange={uploaEntrevistaSociodemografica}/>
                }
                    
                
                

                {
                    sociodemograficasi && formikProps.values.fileSociodemografica 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.sociodemografica_name_saved ? 100 : percentage_upload_entrevista_sociodemografica} label={formikProps.values.fileSociodemografica.name} hasIcon={true} /> 
                        {!(String(formikProps.values.sociodemografica_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.sociodemografica_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE ENTREVISTA SOCIODEMOGRAFICA */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Encuesta DME?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => encuestaDmeSi() } name={'encuesta_dme_si'} checked={encuestadmesi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => encuestaDmeNo() } name={'encuesta_dme_no'} checked={encuestadmeno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>

                {/*FILE ENCUESTA DME */}
                {
                    encuestadmesi &&
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileEncuestaDme.name} 
                            label={fileEncuestaDme.label} 
                               required={true}
                            text={'Encuesta DME'} 
                            onChange={uploadEncuestaDme}/>
                }
                    
                
                

                {
                    encuestadmesi && formikProps.values.fileEncuestaDme 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.encuesta_dme_name_saved ? 100 : percentage_upload_encuesta_dme} label={formikProps.values.fileEncuestaDme.name} hasIcon={true} /> 
                        {!(String(formikProps.values.encuesta_dme_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.encuesta_dme_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE ENCUESTA DME */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


            <Grid size={{ xs: 3 }}>

                <Typography  sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>¿Compromiso SST?</Typography>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <FormControlLabel
                            control={<Checkbox onChange={ () => compromisoSstSi() } name={'compromiso_sst_si'} checked={compromisosstsi} />}
                            label={'Si'}
                        />
                        </div>
                    </Grid>
                    <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormControlLabel
                            control={<Checkbox onChange={ () => compromisoSstNo() } name={'compromiso_sst_no'} checked={compromisosstno} />}
                            label={'No'}
                        />
                        </div>
                    </Grid>
                </Grid>
                {/*FILE COMPROMISO SST */}
                {
                    compromisosstsi && 
                        <UploadButtonField accept={'application/pdf'} 
                            name={fileCompromisoSst.name} 
                            label={fileCompromisoSst.label} 
                               required={true}
                            text={'Compromiso SST'} 
                            onChange={uploadCompromisoSst}/>
                }
                    
                
                

                {
                    compromisosstsi && formikProps.values.fileCompromisoSst 
                    ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                        <LinearProgressWithLabel percentage={formikProps.values.compromiso_sst_name_saved ? 100 : percentage_upload_compromiso_sst} label={formikProps.values.fileCompromisoSst.name} hasIcon={true} /> 
                        {!(String(formikProps.values.compromiso_sst_name_saved).includes('dummy')) && (
      <PreviewPdfButton 
                          fileName={formikProps.values.compromiso_sst_name_saved} 
                          typeUrl="laboral-empleado" 
                          onOpenPdf={props.onOpenPdf} 
                        />
    )}
                        </Card>
                    :
                    ''
                } 
                {/* END FILE COMPROMISO SST */}

            </Grid>
            <Grid size={{ xs: 1}}></Grid>


        </Grid>
        {/* END GRID  */}


    </div>
  )
}

